import { useEffect, useRef, useState } from "react";
import { SOUNDS, startAmbient } from "@/lib/ambient";

export const AmbientPicker = () => {
  const [kind, setKind] = useState("off");
  const [vol, setVol] = useState(0.35);
  const player = useRef(null);

  const pick = (k) => {
    player.current?.stop();
    player.current = k === "off" ? null : startAmbient(k, vol);
    setKind(k);
  };
  useEffect(() => { player.current?.setVolume(vol); }, [vol]);
  useEffect(() => () => player.current?.stop(), []);

  return (
    <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 w-[min(92vw,360px)]" data-testid="ambient-picker">
      <div className="flex gap-1.5 bg-white/5 rounded-full p-1">
        {SOUNDS.map((s) => (
          <button key={s.id} onClick={() => pick(s.id)} data-testid={`ambient-${s.id}`}
            className={`px-3 py-1.5 rounded-full text-xs font-semibold transition-colors ${kind === s.id ? "bg-white text-black" : "text-white/70 hover:text-white"}`}>
            <span className="mr-1">{s.icon}</span>{s.name}
          </button>
        ))}
      </div>
      {kind !== "off" && (
        <input type="range" min="0" max="1" step="0.05" value={vol} onChange={(e) => setVol(Number(e.target.value))}
          className="w-40 accent-white" aria-label="Background volume" data-testid="ambient-volume" />
      )}
    </div>
  );
};
